<mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="!panelOpen">{{ title }}</h2>
            </div>
            <div>
                <mat-icon *ngIf="!panelOpen" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="panelOpen" class="header-toggle">
                    expand_less
                </mat-icon>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="mx-2 mb-5" *ngIf="dataSource.length > 0">
        <div class="row">
            <div class="col d-flex flex-column">
                <table mat-table [dataSource]="dataSource" class="mb-3">
                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let element">
                            <ng-container *ngIf="element?.policy_price?.description">
                                {{ element?.policy_price?.description }}
                            </ng-container>
                            <ng-container *ngIf="!element?.policy_price?.description">
                                {{ element?.policy?.name }}
                            </ng-container>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="contents_coverage">
                        <th mat-header-cell *matHeaderCellDef>Contents Coverage</th>
                        <td mat-cell *matCellDef="let element">
                            {{ !element?.policy.damage_coverage ? '$0.00' : element?.policy.damage_coverage | currency }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="ho_liability_coverage">
                        <th mat-header-cell *matHeaderCellDef>Liability Coverage</th>
                        <td mat-cell *matCellDef="let element">
                            {{ !element?.policy.liability_coverage ? '$0.00' : element?.policy.liability_coverage | currency }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="dwelling_coverage">?
                        <th mat-header-cell *matHeaderCellDef>Guest Liability / Damage Coverage</th>
                        <td mat-cell *matCellDef="let element">
                            {{ !element?.policy.dwelling_coverage ? '$0.00' : element?.policy.dwelling_coverage | currency }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="pricing_model">
                        <th mat-header-cell *matHeaderCellDef>Pricing Model</th>
                        <td mat-cell *matCellDef="let element">
                            {{ this.primaryPolicyPricingModel }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="stay_length">
                        <th mat-header-cell *matHeaderCellDef>Stay Length</th>
                        <td mat-cell *matCellDef="let element">
                            {{ this.numberOfNightsFrom }} - {{ this.numberOfNightsTo }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef>Price</th>
                        <td mat-cell *matCellDef="let element">
                            {{ this.insurancePolicyPrice | currency }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="extra_night_price">
                        <th mat-header-cell *matHeaderCellDef>Extra Night Price</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element?.policy_price.extra_night_price | currency }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnsProps"></tr>
                    <tr mat-row *matRowDef="let row; columns: columnsProps;" class="text-center"></tr>
                </table>
            </div>
        </div>
    </div>
    <div class="mb-4 mr-3 px-4">
        <div class="tab-body">
            <div class="d-flex flex-column total-column">
                <div class="d-flex flex-row">
                    <h4 class="cost-text">Insurance Cost:</h4>
                    <span class="total-numbers">{{ this.insuranceCost | currency }}</span>
                </div>
                <div *ngIf="this.policyTableData" class="text-muted mt-2">
                    {{ this.policyTableData.policy.name }} - (Damage: {{ this.policyTableData.policy.damage_coverage
                    | currency }}, Liability: {{ this.policyTableData.policy.liability_coverage | currency }}, Dwelling:
                    {{ this.policyTableData.policy.dwelling_coverage | currency }})
                </div>
                <div *ngIf="(this.policyTableData?.policy_price?.extra_night_price ?? 0) > 0 && (this.extraNights ?? 0) > 0" class="text-muted mt-2">
                    + {{ this.extraNights }} Extra Nights ({{this.extraNightsPrice | currency }})
                </div>
                <div class="mt-3">
                    <div class="d-flex flex-row">
                        <h4 class="cost-text">Verification Cost:</h4>
                        <span class="total-numbers">{{ this.verificationCost | currency }}</span>
                    </div>
                    <div *ngIf="this.verificationPackage" class="text-muted mt-2">
                        {{ this.verificationPackage.verification_package.name }} - {{
                        this.verificationPackage.verification_package.description }}
                    </div>
                </div>
                <hr class="totals-row-line">
                <div class="d-flex flex-row">
                    <h4 class="total-text">Total:</h4>
                    <span class="cost-total">{{ this.totalCost | currency }}</span>
                </div>
            </div>
        </div>
    </div>
</mat-expansion-panel>